import { lazy } from 'react';

export const CreateNewPageLazy = lazy(() => import('./CreateNewPage'));
